/* eslint-disable no-param-reassign */
export default {
  state: {
    loading: false,
    error: null,
    userMessage: '',
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    setUserMessage(state, payload) {
      state.userMessage = payload;
    },
    clearUserMessage(state) {
      state.userMessage = '';
    },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
    message(state) {
      return state.userMessage;
    },
  },
};
